import { get, post } from "./utils";

// Context
export const getDtiContext = () => get(`/api/v1/context`);

// GET
export const getLMSInfo = () => get(`/api/v1/lms-info`);
export const getLCMSInfo = () => get(`/api/v1/lcms-info`);
export const getStudentOnlineRate = () => get(`/api/v1/student-online-rate`);
export const getInteractiveLessionRate = () => get(`/api/v1/interactive-lession-rate`);
export const getAssessmentTracking = () => get(`/api/v1/assessment-tracking`);
export const getContentsRate = () => get(`/api/v1/contents-rate`);

// CREATE JOB
export const createJobLMSInfo = () => post(`/api/v1/lms-info/scheduler`);
export const createJobLCMSInfo = () => post(`/api/v1/lcms-info/scheduler`);
export const createJobStudentOnlineRate = () => post(`/api/v1/student-online-rate/scheduler`);
export const createJobInteractiveLessionRate = () => post(`/api/v1/interactive-lession-rate/scheduler`);
export const createJobAssessmentTracking = () => post(`/api/v1/assessment-tracking/scheduler`);
export const createJobContentsRate = () => post(`/api/v1/contents-rate/scheduler`);

// GET JOB
export const getJobLMSInfo = () => get(`/api/v1/lms-info/scheduler`);
export const getJobLCMSInfo = () => get(`/api/v1/lcms-info/scheduler`);
export const getJobStudentOnlineRate = () => get(`/api/v1/student-online-rate/scheduler`);
export const getJobInteractiveLessionRate = () => get(`/api/v1/interactive-lession-rate/scheduler`);
export const getJobAssessmentTracking = () => get(`/api/v1/assessment-tracking/scheduler`);
export const getJobContentsRate = () => get(`/api/v1/contents-rate/scheduler`);

export const exportContentsRate = () => "/api/v1/contents-rate/export";
export const exportStudentOnlineRate = () => "/api/v1/student-online-rate/export";
export const exportAssessmentTracking = () => "/api/v1/assessment-tracking/export";

export const submitDtiMetric = (metricId) => post(`/api/v1/${metricId}`);

export const submitLMSInfo = () => submitDtiMetric('lms-info');
export const submitLessonInfo = () => submitDtiMetric('interactive-lession-rate');
